import React from 'react';

const AgentInternalFlags = ({
  visible,
  formData,
  onChange,
  disabled = false,
}) => {
  if (!visible) return null;

  const handlePartyLinkedCheck = (e) => {
    onChange({
      target: { name: 'commission_enabled', type: 'checkbox', checked: e.target.checked },
    });
  };

  return (
    <div className="col-span-2 sm:col-span-2 lg:col-span-5 grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mt-1">
      <label className="flex items-start gap-2 p-3 rounded-xl border border-gray-200 bg-gray-50">
        <input
          type="checkbox"
          name="commission_enabled"
          checked={Boolean(formData.commission_enabled)}
          onChange={handlePartyLinkedCheck}
          disabled={disabled}
          className="mt-0.5 w-4 h-4 text-blue-600 border-gray-300 rounded"
        />
        <span>
          <span className="block text-sm font-medium text-gray-800">Calculate commission</span>
          <span className="block text-xs text-gray-500">
            Auto-on when a contract party is selected. Own-company agents can also opt in. Off means no commission.
          </span>
        </span>
      </label>
      <label className="flex items-start gap-2 p-3 rounded-xl border border-gray-200 bg-gray-50">
        <input
          type="checkbox"
          name="is_pickup_man"
          checked={Boolean(formData.is_pickup_man)}
          onChange={onChange}
          disabled={disabled}
          className="mt-0.5 w-4 h-4 text-blue-600 border-gray-300 rounded"
        />
        <span>
          <span className="block text-sm font-medium text-gray-800">Pickup man</span>
          <span className="block text-xs text-gray-500">
            Same Agent role with simplified running-mode booking. Auto-ML only
            appends an existing same-day sheet. Create ML is hidden.
          </span>
        </span>
      </label>
      <div className="p-3 rounded-xl border border-gray-200 bg-gray-50">
        <label className="block text-sm font-medium text-gray-800 mb-1" htmlFor="tds_percentage">
          TDS on commission (%)
        </label>
        <input
          id="tds_percentage"
          type="number"
          name="tds_percentage"
          value={formData.tds_percentage ?? '0'}
          onChange={onChange}
          disabled={disabled}
          placeholder="0"
          min="0"
          max="100"
          step="0.01"
          className="w-full px-3 py-2 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-400 text-sm bg-white"
        />
        <p className="text-xs text-gray-500 mt-1">
          Deducted from this agent&apos;s booking and delivery commission. 0% means no TDS.
        </p>
      </div>
    </div>
  );
};

export default AgentInternalFlags;
